export class PortalMobileOtpModel {
    SLNO: string;
    HOSPITALNO: string;
    MOBILENO: string;
    OTP: string;
    STATUS: string;
    DATEC: string;
    DATEM: string;
    USERIDC: string;
    USERIDM: string;
    constructor(_SLNO: string, _HOSPITALNO: string, _MOBILENO: string, _OTP: string) {
        this.SLNO = _SLNO;
        this.HOSPITALNO = _HOSPITALNO;
        this.MOBILENO = _MOBILENO;
        this.OTP = _OTP;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Booking/PortalMobileOtpModel.ts